import { inject } from '@angular/core';
import {
  getDowntimeMessage,
  getDowntimeMessageActionState,
  LoadDowntimeMessage,
} from '../../+state';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { RedirectCommand, Router } from '@angular/router';

export const downtimeGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  store.dispatch(LoadDowntimeMessage());

  return store.select(getDowntimeMessageActionState).pipe(
    filter(state => !state.pending),
    switchMap(() => store.select(getDowntimeMessage)),
    map(downtimeMessage =>
      downtimeMessage === null ? new RedirectCommand(router.parseUrl('login')) : true
    )
  );
};
